import SEO from '@/components/SEO';
import usePrerenderReady from '@/lib/usePrerenderReady';

const ProductionHouse = () => {
  usePrerenderReady(false);
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-purple-50 pt-24">
      <SEO title="Production House" description="KalaManch.Art works with production houses looking for actors, singers, dancers, writers, composers, voice artists, editors, and other creative professionals. This partner pathway is designed for teams who want to discover dependable talent and build strong creative collaborations." />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
          <div className="text-6xl mb-6">🎬</div>
          <h1 className="text-4xl sm:text-5xl font-bold gradient-text mb-6">Production House</h1>
          <p className="text-lg text-gray-700 leading-8">
            KalaManch.Art works with production houses looking for actors, singers, dancers, writers, composers,
            voice artists, editors, and other creative professionals. This partner pathway is designed for teams
            who want to discover dependable talent and build strong creative collaborations.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProductionHouse;
